import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDestination = (props) => /* @__PURE__ */ _jsxs("svg", {
	fill: "none",
	height: 62,
	viewBox: "0 0 57 62",
	width: 57,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("filter", {
		id: "a",
		colorInterpolationFilters: "sRGB",
		filterUnits: "userSpaceOnUse",
		height: 64.5685,
		width: 64.5684,
		x: -4,
		y: -3,
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				result: "hardAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in2: "BackgroundImageFix",
				mode: "normal",
				result: "effect1_dropShadow_2921_11289"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				result: "hardAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
			}),
			/* @__PURE__ */ _jsx("feMorphology", {
				in: "SourceAlpha",
				operator: "dilate",
				radius: 1,
				result: "effect2_dropShadow_2921_11289"
			}),
			/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in2: "effect1_dropShadow_2921_11289",
				mode: "normal",
				result: "effect2_dropShadow_2921_11289"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				in: "SourceGraphic",
				in2: "effect2_dropShadow_2921_11289",
				mode: "normal",
				result: "shape"
			})
		]
	}), /* @__PURE__ */ _jsxs("g", {
		filter: "url(#a)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "m14.142 14.1421c7.8105-7.81045 20.4738-7.81045 28.2843 0 7.8105 7.8105 7.8105 20.4738 0 28.2843l-14.1421 14.1421-14.1422-14.1421c-7.81044-7.8105-7.81044-20.4738 0-28.2843z",
			fill: "#fff"
		}), /* @__PURE__ */ _jsx("path", {
			d: "m28.2803 12.04c-3.214 0-6.3557.9531-9.028 2.7387-2.6723 1.7855-4.7551 4.3234-5.9851 7.2927-1.2299 2.9693-1.5517 6.2367-.9247 9.3889.627 3.1521 2.1747 6.0476 4.4473 8.3202s5.1681 3.8203 8.3203 4.4473 6.4195.3052 9.3888-.9247 5.5072-3.3128 7.2928-5.985c1.7855-2.6723 2.7386-5.8141 2.7386-9.0281-.0046-4.3083-1.7181-8.4389-4.7646-11.4854-3.0464-3.0465-7.1771-4.76-11.4854-4.7646zm5 20.625c0 .1658-.0659.3248-.1831.442s-.2762.183-.4419.183h-8.75c-.1658 0-.3248-.0658-.442-.183s-.183-.2762-.183-.442v-8.75c0-.1657.0658-.3247.183-.4419s.2762-.1831.442-.1831h8.75c.1657 0 .3247.0659.4419.1831s.1831.2762.1831.4419z",
			fill: "#fbb243"
		})]
	})]
});
export default SvgDestination;
